import { render, staticRenderFns } from "./FileChooserFileItem.vue?vue&type=template&id=88fbe7b2&v-if=isReadable&"
import script from "./FileChooserFileItem.vue?vue&type=script&lang=js&"
export * from "./FileChooserFileItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports